<template>
  <b-modal
    hide-footer
    id="FASTTRACK_ROLE_MODAL"
    ref="REF_FASTTRACK_ROLE_MODAL"
    size="xl"
    @shown="onModalShown"
  >
    <div class="container">
      <b-overlay :show="loading" rounded="sm">
        <!-- หัวข้อ -->
        <b-card class="text-center mb-1">
          <h3>{{ title }}</h3>
        </b-card>
        <!-- ตารางแสดงข้อมูล -->
        <b-card class="col-12">
          <b-col cols="12">
            <CommonTable ref="commonTable" @handleOverlay="onSetLoading" />
          </b-col>
        </b-card>
      </b-overlay>
    </div>
  </b-modal>
</template>
<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BButton,
  BFormTextarea,
  BOverlay,
  BCard,
} from "bootstrap-vue";
import CommonTable from "./commonTable.vue";
export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    BCard,
    BOverlay,
    CommonTable,
  },
  props: {
    filter: {
      year: "",
      yearEnd: "",
      startDate: "",
      endDate: "",
      userId: null,
      departmentId: "",
    },
  },
  data() {
    return {
      title: "ตารางแสดงรายละเอียด",
      loading: false,
      keyword: "",
    };
  },
  created() {
    // //console.log"created.modal.opened .filter", this.filter);
  },
  mounted() {
    // //console.log"mounted.modal.opened .filter", this.filter);
  },
  methods: {
    onSetLoading(isShow) {
      this.loading = isShow;
    },
    onModalShown() {
      const _commontable = this.$refs["commonTable"];
      //console.log"methods.modal.onmodalshown ._commontable", _commontable);

      _commontable.onSearchSubmit(this.keyword, this.filter);
    },
    onSetData(title, keyword, data) {
      this.title = `ตารางแสดงรายละเอียด${title}`;
      this.keyword = keyword;
      this.filter = data;
    },
    // onSetTitle(title) {
    //   this.title = `รายละเอียด${title}`;
    // },
  },
};
</script>